export const StepsIndicators = ({
	activeStep,
	totalSteps,
}: {
	activeStep: number
	totalSteps: number
}) => {
	return (
		<div className='flex items-center gap-4'>
			<div className='bg-primary/10 flex flex-1 items-center justify-center rounded-full p-1'>
				<div
					className='from-primary/20 to-primary mr-auto h-2 rounded-full bg-gradient-to-r transition-all duration-300'
					style={{ width: `${(100 / totalSteps) * activeStep}%` }}
				/>
			</div>

			<div className='text-muted-foreground text-sm'>
				{activeStep}/{totalSteps}
			</div>
		</div>
	)
}
